/* eslint-disable @typescript-eslint/no-explicit-any */

export function noopReducer(defaults: any) {
  return (state: any) => state || defaults;
}
